import React, { lazy } from 'react';
import { MapPin, Phone, Mail, ChevronRight } from 'lucide-react';
interface NewsletterSectionProps {
  /**
   * Optional data-id for testing
   */
  'data-id'?: string;
}
export const NewsletterSection: React.FC<NewsletterSectionProps> = ({
  'data-id': dataId
}) => {
  return <section className="bg-white py-20 px-8" data-id="element-124">
      <div className="max-w-7xl mx-auto" data-id="element-125">
        {/* Centered Title Section */}
        <div className="text-center mb-8" data-id="element-126">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-127"></div>
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-128">
            Visit Us
          </div>
          <h2 className="font-heading text-4xl lg:text-5xl text-neutral-900 mb-6 leading-tight" data-id="element-129">
            How to Get Here
          </h2>
          <p className="text-neutral-600 mb-6 leading-relaxed text-lg max-w-2xl mx-auto" data-id="element-130">
            Located at the gateway to the Hunter Valley wineries, we are easily
            accessible and the perfect first stop on your wine country journey.
          </p>
          {/* Centered Address Information */}
          <div className="flex items-start gap-4 justify-center mx-auto mb-8" data-id="element-131">
            <div data-id="element-132">
              <p className="text-neutral-900 font-medium mb-2" data-id="element-133">
                Peterson House
              </p>
              <p className="text-neutral-600 leading-relaxed" data-id="element-134">
                2457 Broke Road, Pokolbin, NSW, 2320
              </p>
            </div>
          </div>
        </div>
        {/* Map - Full Width */}
        <div className="w-full h-[550px] bg-neutral-100 shadow-sm relative" data-id="element-135">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!3d3348.8!2d151.3!3d-32.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDQ4JzAwLjAiUyAxNTHCsDE4JzAwLjAiRQ!5e0!3m2!1sen!2sau!4v1234567890" width="100%" height="100%" style={{
          border: 0
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Peterson House Location" data-id="element-136" />
          <a href="https://www.google.com/maps/dir//Peterson+House+Hunter+Valley" target="_blank" rel="noopener noreferrer" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 inline-flex items-center gap-2 bg-brand-pink text-white px-4 py-4 text-sm font-medium hover:bg-brand-pink/90 transition-colors rounded-none group shadow-md" data-id="element-137">
            Get Directions
            <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-138" />
          </a>
        </div>
      </div>
    </section>;
};